import React from 'react';
import { ToolTipComponent } from '../../common/ToolTipComponent';
import SvgIcon from '../../common/SvgIcon';

export const IBANInfoIcon = ({ content, scope }) => (
  <ToolTipComponent
    hasSvg={true}
    trigger="manual"
    placement="bottom"
    childComponent={
      <SvgIcon
        id="icon-Information"
        width="20px"
        height="20px"
        className="account-summary__more__balances__title__icon"
      />
    }
    popoverChildComponent={
      <p className="type--bute">{content.ibanAndBicInfo}</p>
    }
    scope={scope}
  />
);
